import { useState, useEffect } from 'react';
import Axios from "axios";
import { DeactivateVendors, GetListOfAllVendorsByEmployeeID, GetListOfVendorsByEmployeeID } from '../apiconstants/constants';
import { Link, useLocation } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Swal from 'sweetalert2';
import { Button, Modal } from 'react-bootstrap';
import { useCountry } from '../contexts/countrycodecontext.js';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ListOfVendors = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  let Guid="";

  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  
  const roleID = localStorage.getItem("roleID")
  const [data, setData] = useState([]);
  const [perPage] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
    const [showIcon, setShowIcon] = useState('list');
    const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
    const [showModal,setShowModal] = useState(false)
    const [vendorId, setVendorId] = useState(null);
    const [status, setStatus] = useState(null);
    const { selectedCountry} = useCountry();
    const [statusFilter, setStatusFilter] = useState("Active"); // default Active
const token = localStorage.getItem("jwtToken");
    const handleViewToggle = (type) => {
      setViewType(type);
      setShowIcon(type)
    };
    
const handleCancel = () => {
  setShowModal(false);
};
  if(roleID==3){
    Guid = employerGuid
   }
   else{
     Guid= guid
   }
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };

  const handleDeactivateVendor = (vGuid,isActive) => {
    setVendorId(vGuid);
    setStatus(isActive)
    setShowModal(true)
  };

  const GetCandidateList = () => {
    setIsLoading(true);

    const GetapiUrl = GetListOfAllVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

    Axios.get(GetapiUrl,
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then((result) => {
        setIsLoading(false);

          const cleanData = result.data.map(v => ({
      ...v,
      isActive: v.isActive === true || v.isActive === "true"
    }));

    setCandidateData(cleanData);
      }).catch((error) => {
        console.log("Error" + error);
      });
  };

      const handleUserStatus = () => {
        
          const APIURL = `${DeactivateVendors.APIURL}?UserGuid=${Guid}&VGuid=${vendorId}&type=${!(status)}`;
  
          setIsLoading(true); // Set loading state before API call
  
        Axios.put(APIURL, null, {
    headers: { Authorization: `Bearer ${token}` }
  })
              .then((result) => {
        
                  setIsLoading(false); // Set loading state to false after API call
                  setCandidateData(prevVendors =>
                    prevVendors.map(vendor =>
                        vendor.vGuid == vendorId ? { ...vendor, isActive: !status } : vendor
                    )
                );
                  // Show success message based on API response
                  if (result.data.message === "Vendor Activated successfully.") {
                      Swal.fire({
                          position: 'center',
                          icon: 'success',
                          title: 'Activated Successfully',
                          showConfirmButton: false,
                          timer: 5000,
                      });
                      GetCandidateList();
                  } else if (result.data.message === "Vendor Deactivated successfully.") {
                      Swal.fire({
                          position: 'center',
                          icon: 'success',
                          title: 'Deactivated Successfully',
                          showConfirmButton: false,
                          timer: 5000,
                      });
                      GetCandidateList();
                  }
                
                  setShowModal(false);

              })
              .catch((error) => {
                  console.error("Error: ", error); // Log error for debugging
                  setIsLoading(false); // Set loading state to false in case of error
  

              });
      };

  useEffect(() => {
    GetCandidateList();
  }, [selectedCountry,statusFilter]); // Fetch data only once when the component mounts

  useEffect(() => {
     let filteredData = candidateData;
  if (statusFilter == "Active") {
    filteredData = filteredData.filter(c => c.isActive === true);
  } else if (statusFilter == "Inactive") {
    filteredData = filteredData.filter(c => c.isActive === false);
  }
  // Search filter
  filteredData = filteredData.filter(candidate =>
    candidate?.vendorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate?.vendorCompanyName.toLowerCase().includes(searchTerm.toLowerCase())
  );
   if (filteredData.length === 0) {
    setData([]);   // ❌ don’t touch candidateData here
    setPageCount(0);
    return;
  }

    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType == 'grid' ? slice.map((data) => {
      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.vGuid}>
        <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 400, height: 400, borderRadius: 20 }}>
          <div className='card-header' style={{ background: "none", minHeight: 140 }}>
            <div className='row'>
              
              <div className='col-8'>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Name</Tooltip>)}>
                  <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.vendorName}</b></p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Email</Tooltip>)}>
                  <h5 style={{ fontSize: 18 }}>{data.vendorEmail}</h5>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="card-body">
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip"  {...props}><span className="tooltip2">Mobile Number</span></Tooltip>)}>
              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-cogs" aria-hidden="true"></i> {data.phoneNumber}  </p>
            </OverlayTrigger>
            {data.vendorAddress&&   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Website</Tooltip>)}>
          <p style={{ fontSize: 14, textAlign: 'justify' }}>
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                {data.vendorAddress}
              </p>
            </OverlayTrigger>}
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Company Name</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user-tie" aria-hidden="true"></i> {data.vendorCompanyName} </p>
            </OverlayTrigger>
           {data.vendorCompanyAddress&& <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Company Address</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-chart-line" aria-hidden="true"></i> {data.vendorCompanyAddress}</p>
            </OverlayTrigger>}
          
            <div className='card-footer d-flex justify-content-between' style={{ background: "none" }}>
              <Link style={{ }} to={"/Employer/EditClientProfile?VGuid=" + data.vGuid}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                  <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
              </Link>
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {data.isActive ? 'Deactivate Vendor' : 'Activate Vendor'}</Tooltip>)}>
                             <button onClick={() => handleDeactivateVendor(data.vGuid, data.isActive) }style={{ background: "none", border: "none" }}>
                            <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                            </button>
               
                           </OverlayTrigger>
             </div>
          </div>
        </div>
      </div>
      )
    }) :
    <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
   <table className="table" 
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
  }}>
   <thead>
        <tr>
          <th>Client Name</th>
          <th>Client Email</th>
          <th>Mobile Number</th>
          <th>Company Website</th>
          <th>Client Company Name</th>
          <th>Client Company Address</th>
           <th>Actions</th>
          </tr>
      </thead>
  <tbody>
    {slice?.map((data, index) => (
      <tr key={index}>
        <td>{data.vendorName}</td>
        <td>{data.vendorEmail}</td>
        <td>{data.phoneNumber}</td>
        <td>{data.vendorAddress}</td>
        <td>{data.vendorCompanyName}</td>
        <td>{data.vendorCompanyAddress}</td>
        <td>
          <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
            <Link to={`/Employer/EditClientProfile?VGuid=${data.vGuid}`}>
              <OverlayTrigger
                placement="bottom"
                overlay={(props) => (
                  <Tooltip id="tooltip" {...props}>
                    Edit
                  </Tooltip>
                )}
              >
                <button style={{ background: "none", border: "none" }}>
                  <i
                    className="fa fa-edit"
                    aria-hidden="true"
                    style={{ fontSize: 14, color: "#00a7ac" }}
                  ></i>
                </button>
              </OverlayTrigger>
            </Link>
            <OverlayTrigger
              placement="bottom"
              overlay={(props) => (
                <Tooltip id="tooltip" {...props}>
                  {data.isActive ? "Deactivate Vendor" : "Activate Vendor"}
                </Tooltip>
              )}
            >
              <button
                onClick={() => handleDeactivateVendor(data.vGuid, data.isActive)}
                style={{ background: "none", border: "none" }}
              >
                <i
                  className={`fa fa-${data.isActive ? "toggle-on" : "toggle-off"}`}
                  aria-hidden="true"
                  style={{ fontSize: 14, color: "#00a7ac" }}
                ></i>
              </button>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    ))}
  </tbody>
</table>

  </div>

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm, candidateData, perPage,viewType,statusFilter]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      <div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
        <div> <h2 className="" style={{ color: "#00a7ac" }}>Client Directory</h2></div>
  <div style={{display:'flex',justifyContent:'space-between'}}>
 
              <div>
<OverlayTrigger placement="bottom" overlay={<Tooltip>Search by Client Name or Company Name</Tooltip>}>
              <input
              id="searchvendor"
                type="text"
                placeholder="Search by Client Name or Company Name"
                className="form-control"
                value={searchTerm}
                onChange={handleSearch}
                
              />
             </OverlayTrigger>
              </div>
              <div style={{ display: 'flex', gap: '10px',marginRight:15 }}>
<OverlayTrigger placement="bottom" overlay={<Tooltip>Apply Filters</Tooltip>}>

  <select
  style={{width:100,height:50}}
    className="form-control"
    value={statusFilter}
    onChange={(e) => { setStatusFilter(e.target.value); setOffset(0); }}
  >
    <option value="All">All</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>
  </OverlayTrigger>
</div>

             <div>
                               {showIcon === 'grid' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleViewToggle('list')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
              
                {showIcon === 'list' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleViewToggle('grid')}
                      style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                      <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }}></i>
                    </button>
                  </OverlayTrigger>
                )}
                </div>
                <div>
             <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Client</Tooltip>)}>
                <Link to="/Employer/AddClientProfile">
                  <button className="btn btn-primary ml-3 mr-3" btn-type="button"><i className="fa fa-plus"></i></button>
                </Link>
              </OverlayTrigger>
              </div>
               
  </div>
        </div>
        <hr />
        {/* {candidateData.length===0 || data.length === 0 && (
  <div className="pb-5 text-center">
    <img title='No Data'  alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
  </div>
)} */}
 
  

        <div className="row mt-5 pb-3">
          {isLoading ? <center><LoadingSpinner /></center> : <> {data}</>}
        </div>
        {candidateData.length === 0  || data.length ===0 && (
  <div className="pb-5 text-center">
    <img title='No Data' alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
  </div>
)}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

        <Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
                <Modal.Header closeButton>
                  <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to Activate/Deactivate this Client?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCancel}>No</Button>
                  <Button variant="primary" onClick={handleUserStatus}>Yes</Button>
                </Modal.Footer>
              </Modal>
      </div>
    </ConsultantLayout>
  );
}

export default ListOfVendors;
